var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { Controller } from "react-hook-form";
import { phoneNumberInputTestId } from "./constants";
import { PhoneNumber, WORLD_COUNTRIES } from "@gemini/patterns-phonenumber";
import { brandConfiguration } from "@/brands/config";
const { phoneCountryCode, phonePrioritizedCountries } = brandConfiguration;
export const PhoneNumberE164Input = ({ control, required }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    return (_jsx(Controller, { name: "phoneNumber", control: control, defaultValue: "", render: (_a) => {
            var _b = _a.field, { value } = _b, field = __rest(_b, ["value"]), { fieldState: { error } } = _a;
            return (_jsx(PhoneNumber, Object.assign({ defaultCountry: phoneCountryCode }, field, { label: t("contact.form.phone"), countries: WORLD_COUNTRIES, isFullWidth: true, emptyState: {
                    title: t("contact.form.phone_error_empty"),
                    description: t("contact.form.phone_placeholder"),
                }, testId: phoneNumberInputTestId, placeholder: t("contact.form.phone_placeholder"), error: error === null || error === void 0 ? void 0 : error.message, hasNecessityIndicator: required, value: value, isDisabled: isPreviewMode, prioritizedCountries: phonePrioritizedCountries })));
        } }));
};
